export const STATE_SUCCESS = 'STATE_SUCCESS';
export const STATE_LOADING = 'STATE_LOADING';
export const STATE_FAIL = 'STATE_FAIL';
